<template>
  <form-main @back="makeSureBack">
    <template slot="nav">
      <div class="vita-form-nav">
        <p>
          {{enroll_level | enrollLevel}}培训意向选择
        </p>
      </div>
    </template>
    <template slot="main">
      <div class="vita-form-main">
        <div class="content">
          <template>
            <vue-scroll :ops="ops">
              <el-form label-width="80px" :model="formaDate"  ref="formTime">
                <div style="padding:0px 30px 0px 25px;">
                  <fieldset class="vita-form-fieldset" style="border: 1px solid white;padding: 10px"  >
                    <legend>培训报名</legend>
                    <!--                  <el-form :model="formaDate" label-width="80px">-->
                    <el-row>
                      <el-col :span="16">
                        <el-form-item label="报名" >
                          <el-input v-model.trim="formaDate.enroll_name"
                                    :disabled="true"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="注册协会" prop="org_id"
                        >
                          <el-select v-model="formaDate.org_id"
                                     clearable
                                     disabled
                                     filterable
                                     placeholder="请选择注册协会">
                            <el-option
                                    v-for="item in organList"
                                    :key="item.org_id"
                                    :label="item.org_abbreviation"
                                    :value="item.org_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </fieldset>
                </div>
                <div class="form-wrap">

                  <template v-if="monthsList.length && time_change_way ==='month'">
                    <template  v-if="is_choose_classDate">
                      <div class="upfile">
                        <fieldset class="vita-form-fieldset physical">
                          <legend>意向选择</legend>
                          <el-row :gutter="10">
                            <el-col :span="10">
                                <el-form-item label="第一志愿" prop="intention_class_date_one" :rules="[{required: is_choose_classDate == 1 ? true : false,message:'请填写第一志愿培训班月份',trigger: 'change'}]">
                                  <el-select  v-model="formaDate.intention_class_date_one" clearable placeholder="请选择第一志愿培训班月份" style="width:700px">
                                    <el-option
                                      v-for="item in selectForIntentionOne"
                                      :key="item.value"
                                      :label="item.label"
                                      :disabled="item.disabled || item.isTimeDisabled"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="第二志愿">
                                  <el-select  v-model="formaDate.intention_class_date_two" clearable placeholder="请选择第二志愿培训班月份" style="width:700px">
                                    <el-option
                                      v-for="item in selectForIntentionTwo"
                                      :key="item.value"
                                      :label="item.label"
                                      :disabled="item.disabled || item.isTimeDisabled"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                            </el-col>
                            <!--<el-col :span="12">-->
                              <!--<p v-if="enroll_type == 'common' && is_speediness_train === 0 && isShowTenderTips">-->
                                <!--您的最高等级获取时间为：<span class="red-color">{{ rank_date | timeFormat('yyyy-MM-DD') }}</span>；根据<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，您只能选择：<span class="red-color">{{ rank_date | getAvaibleTimeStartForSign}}</span>&nbsp;以后的时间段；-->
                              <!--</p>-->
                            <!--</el-col>-->
                          </el-row>
                         
                        </fieldset>
                      </div>
                    </template>
                  </template>
                  <template v-if="monthsListPeriods.length && time_change_way ==='periods'">
                    <template  v-if="is_choose_classDate">
                      <div class="upfile">
                        <fieldset class="vita-form-fieldset physical">
                          <legend>意向选择</legend>
                          <el-row :gutter="10">
                            <el-col :span="10">
                              <el-form-item label="第一志愿" prop="intention_class_periods_one" :rules="[{required: is_choose_classDate == 1 ? true : false,message:'请选择第一志愿培训班期数',trigger: 'change'}]">
                                <el-select  v-model="formaDate.intention_class_periods_one" clearable placeholder="请选择第一志愿培训班期数" style="width:700px">
                                  <el-option
                                    v-for="item in selectForIntentionOnePeriods"
                                    :key="item.value"
                                    :label="item.label"
                                    :disabled="item.disabled || item.isTimeDisabled"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                              <el-form-item label="第二志愿">
                                <el-select  v-model="formaDate.intention_class_periods_two" clearable placeholder="请选择第二志愿培训班期数" style="width:700px">
                                  <el-option
                                    v-for="item in selectForIntentionTwoPeriods"
                                    :key="item.value"
                                    :label="item.label"
                                    :disabled="item.disabled || item.isTimeDisabled"
                                    :value="item.value">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                            <!--<el-col :span="12">-->
                              <!--<p v-if="enroll_type == 'common' && is_speediness_train === 0 && isShowTenderTips">-->
                                <!--您的最高等级获取时间为：<span class="red-color">{{ rank_date | timeFormat('yyyy-MM-DD') }}</span>；根据<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，您只能选择：<span class="red-color">{{ rank_date | getAvaibleTimeStartForSign}}</span>&nbsp;以后的时间段；-->
                              <!--</p>-->
                            <!--</el-col>-->
                            <el-col :span="24">
                              <p class="red-color">
                                最终时间以录取通知为准，培训时间可能会根据具体情况进行调整，培训开始前将通过短信形式通知拟录取教练员。
                              </p>
                            </el-col>
                          </el-row>
        
                        </fieldset>
                      </div>
                    </template>
                  </template>
                  <div class="upfile"  v-if="showNotification">
                       <fieldset class="vita-form-fieldset accident">
                      <legend>免责声明</legend>
                      <div class="fujian">
                        <div class="uploadFujian">
                          <span v-if="showNotification == 1" style="color: #f56c6c; margin-right: 3px;">*</span><span class="suc btn" @click="handleClick">请确认并同意《免责声明》</span>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div >
                    <p style="margin: 8px 0 ">
                      <el-checkbox v-model="checked" />
                      我已阅读并同意以下内容</p>
                    <p>1.我已阅读<a href="/uploads/import_tpl/中国足球协会教练员培训管理规定.pdf" target="_blank" style="color: #4cd964">《中国足球协会教练员培训管理规定》（2023年版）</a>，并了解其中关于教练员培训的相关要求。</p>
                    <p>2.本人承诺提交的全部信息和证明材料均真实、准确、有效，没有隐瞒或虚构任何事实，也没有买卖或造假等不诚信行为。</p>
                    <p>3.如本人违反以上承诺，我将承担由此产生的一切后果，愿意接受中国足协相应的处罚。</p>
                    <!--<p>4.我已阅读<a href="/uploads/import_tpl/中国足协教练员培训班管理规定告知书.pdf" target="_blank" style="color: #4cd964">《中国足协教练员培训班管理规定告知书》</a></p>-->
                  </div>
                </div>
              </el-form>
            </vue-scroll>
          </template>
        </div>
        <div class="btns">
          
          <el-button type="primary" @click="makeSureCommit('commit',enroll_type)" >提交</el-button>
          
          <el-button type="danger" @click="makeSureBack">取消</el-button>
        </div>
        <yioks-tips :showTips="submitTips" :tips="msg" @hideTips="hideCommitTips" :loading="loading"></yioks-tips>
        <yioks-tips :showTips="backTips" tips="确定放弃修改并返回吗？" @hideTips="hideBackTips"></yioks-tips>
        <el-dialog
          title=""
          :visible.sync="isShowOntification"
          width="680px"
          :close-on-click-modal="false"
          :show-close="false"
          :top="'15vh'"
          custom-class="no-padding"
          :before-close="handleNotificationClose">
          <div class="word-wrapper">
            <vue-scroll :ops="opsGrey">
              <div class="wrod-content">
                <div class="word-box">
                  <word-info></word-info>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div class="confrimBox">
              <el-button :type="isConfirmBtnAvaible ? 'primary' : 'info'" :disabled="!isConfirmBtnAvaible" @click="handleConfirmRead">我已经确认 <span v-if="timerCount <= 30 && timerCount > 0">({{timerCount}}s)</span></el-button>
            </div>
        </el-dialog>
      </div>
    </template>
  </form-main>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";

import { mapMutations } from "vuex";
import { storageData } from "@/assets/js/storage";
import { registration_report_view ,organList,enroll_choose_again} from "@/api/ab_signup/api";
import { getAvaibleTimeStartForSign } from '@/assets/js/yioksFilters';
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { classLevelForNewUser } from "@/assets/js/status";
export default {
  name: "enroll_choose_again",
  data() {
    const MAXCOUNT = 30;  // 30s
    return {
      ops: ops(),
      opsGrey: ops(true),
      showJobTemplate:0,
      is_choose_classDate:0,
      showNotification:0,
      months: [],
      monthsList: [],
      monthsListPeriods: [],
      enroll_level:'',
      time_change_way:'',
      loading:false,
      checked:false,
      enroll_type:'',
      train_way:'',
      organList:[],
      formaDate: {
        enroll_uuid: this.$route.query.signId,
        submit_status: "",
        intention_class_date_one: '',  // 志愿一
        intention_class_date_two: '',  // 志愿二
        intention_class_periods_one: '',  // 志愿一 期数
        intention_class_periods_two: '',  // 志愿二 期数
      },
      msg: "",
      fileUpHeaders: {
        "X-Token": storageData.getToken(),
        "X-UserType": storageData.getUserType()
      },
      backTips: false,
      submitTips: false,
      rank_date: 0,
      is_speediness_train: 0,
      isShowOntification: false,    // 显示弹窗
      isConfirmBtnAvaible: false,   // 已读按钮可用
      isReadStatus: false,
      btnTimer: null,
      timerCount: 10,  // 10s
      isShowTenderTips: false,
      matriculate_status: '',
    };
  },

  filters: {
    getAvaibleTimeStartForSign,
    enrollLevel(level) {
      return classLevelForNewUser(level);
    },
  },
  created() {
    this.getOrganList();
    this.getInfo();
  },
  components: {
    "form-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "word-info": () => import("@/views/Registration/vita/NotificationWords"),
  },

  computed: {
    selectForIntentionOne() {
      const defaultList = this.monthsList;
      if(!this.formaDate.intention_class_date_two) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_date_two === item.value
          }
        })
      }
    },
    selectForIntentionTwo() {
      const defaultList = this.monthsList;
      if(!this.formaDate.intention_class_date_one) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_date_one === item.value
          }
        })
      }
    },
    selectForIntentionOnePeriods() {
      const defaultList = this.monthsListPeriods;
      if(!this.formaDate.intention_class_periods_two) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_periods_two === item.value
          }
        })
      }
    },
    selectForIntentionTwoPeriods() {
      const defaultList = this.monthsListPeriods;
      if(!this.formaDate.intention_class_periods_one) {
        return defaultList.map(item => ({
          ...item,
          disabled: false
        }))
      } else {
        return defaultList.map(item => {
          return {
            ...item,
            disabled: this.formaDate.intention_class_periods_one === item.value
          }
        })
      }
    },
  },
  methods: {
    ...mapMutations(["updateUserInfo", "updateUserImg"]),
    requiredItem,
    getInfo() {
      const momentJs = require('moment');
      registration_report_view({ enroll_uuid: this.$route.query.signId }).then(
        res => {
          let {org_id,enroll_name,intention_class_date_one, intention_class_date_two, classPhase, rank_date, matriculate_status,intention_class_periods_one,intention_class_periods_two}=res.data.result.enrollMap;
          // if(intention_class_date){
          //   this.formaDate.checkedMonth = JSON.parse(intention_class_date);
          // }
          matriculate_status && (this.matriculate_status = matriculate_status)
          intention_class_date_one && (this.formaDate.intention_class_date_one = intention_class_date_one)
          intention_class_date_two && (this.formaDate.intention_class_date_two = intention_class_date_two)
          intention_class_periods_one && (this.formaDate.intention_class_periods_one = intention_class_periods_one)
          intention_class_periods_two && (this.formaDate.intention_class_periods_two = intention_class_periods_two)
          const {enroll_level,is_choose_classDate,class_end,class_start,is_notification, is_speediness_train, enroll_type,time_change_way}=res.data.result.enroll;
          try {
            const momentJs = require('moment');
            const avaibleTimeStand = momentJs(rank_date).add(13, 'M').format('x');
            const timeRes = Number(avaibleTimeStand) < class_start;
            if(timeRes) {
              this.isShowTenderTips = false;
            } else {
              this.isShowTenderTips = true;
            }
          } catch(err) {
            console.log('timeStamp formate function is error')
            this.isShowTenderTips = true;
          }
          
          this.enroll_level=enroll_level
          this.is_speediness_train = is_speediness_train;
          this.enroll_type = enroll_type;
          this.time_change_way = time_change_way;
//          if (enroll_level==='PRO'||enroll_level==='P'||enroll_level==='0'){
//            this.showJobTemplate=true;
//          }
          
          // 计划开班时间段 返回月份
          let class_starts = this.$yioks.time(class_start);
          let class_ends = this.$yioks.time(class_end);
          this.months = this.$yioks.getMonthBetween(class_starts,class_ends);
          this.monthsList = [];
          this.monthsListPeriods = [];
          rank_date && (this.rank_date = rank_date);
          if(classPhase.length && this.time_change_way === 'month') {
            classPhase.forEach(item => {
              const { start_date, end_date } = item;
              const momentJs = require('moment');
              let timeAvaible;   // true: 当前时间段可用； false 不可用
              if(is_speediness_train == 0 && rank_date && enroll_type == 'common') {
                // console.log('start check', momentJs(start_date).subtract(12, 'M').format('yyyy-MM'))
                // console.log('stand time', momentJs(rank_date).format('yyyy-MM'))
                // console.log('res',  momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M'))
                timeAvaible = momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M');
              } else {
                timeAvaible = true;
              }
              const tentionMonthList = {
                label: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                // value: JSON.stringify(item),
                value: `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`,
                meta: item,
                disabled: false,
                isTimeDisabled: !timeAvaible,
              }
              this.monthsList.push(tentionMonthList)
            })
          }
          if(classPhase.length && this.time_change_way === 'periods') {
            classPhase.forEach((item,index) => {
              const { start_date, end_date,start_date_two,end_date_two,province_name,city_name } = item;
              const momentJs = require('moment');
              let timeAvaible;   // true: 当前时间段可用； false 不可用
              if(is_speediness_train == 0 && rank_date && enroll_type == 'common') {
                // console.log('start check', momentJs(start_date).subtract(12, 'M').format('yyyy-MM'))
                // console.log('stand time', momentJs(rank_date).format('yyyy-MM'))
                // console.log('res',  momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M'))
                timeAvaible = momentJs(start_date).subtract(12, 'M').isAfter(rank_date, 'M');
              } else {
                timeAvaible = true;
              }
  
              let lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM")}，阶段二：${momentJs(end_date).format("yyyy-MM")}`;
              let value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM")},${momentJs(end_date).format("yyyy-MM")}`;
  
              if(start_date_two){
                lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM-DD")} 至 ${momentJs(end_date).format("yyyy-MM-DD")}，阶段二：${momentJs(start_date_two).format("yyyy-MM-DD")} 至 ${momentJs(end_date_two).format("yyyy-MM-DD")}`;
    
                value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM-DD")}至${momentJs(end_date).format("yyyy-MM-DD")},${momentJs(start_date_two).format("yyyy-MM-DD")}至${momentJs(end_date_two).format("yyyy-MM-DD")}`;
              }
              if(province_name){
                lebelName = lebelName + "，" + province_name + city_name;
                value1 = value1 + "," + province_name + city_name;
              }
              lebelName = lebelName+'）';
              const tentionMonthList = {
                label: lebelName,
                // value: JSON.stringify(item),
                value: value1,
                meta: item,
                disabled: false,
                isTimeDisabled: !timeAvaible,
              }
              this.monthsListPeriods.push(tentionMonthList)
            })
          }
          
          this.showNotification = is_notification;
          this.is_choose_classDate = is_choose_classDate;
         
          enroll_name && (this.formaDate.enroll_name=enroll_name);
          org_id && (this.formaDate.org_id=org_id);
          this.enroll_type=res.data.result.enroll.enroll_type;
          this.train_way=res.data.result.enroll.train_way;
        }
      ).catch(err=>{
        console.log(err)
      });
    },
    
    getOrganList(){
      organList({}).then(
              ({ data: { result, status } }) => {
                if (status === 0) {
                  this.organList = result.list;
                }
              }
      );
    },
    makeSureBack() {
      this.backTips = true;
    },
    makeSureCommit(submit,type) {
      if(submit ==='commit'){
        // if(this.is_choose_classDate === 1){
          // if(this.formaDate.checkedMonth.length === 0){
          //   if(this.months.length > 0){
          //     this.$message.error("请至少选择一个意向培训班月份");
          //     return false;
          //   }
          // }
        // }
        
        if(this.showNotification === 1 && !this.isReadStatus){
            this.$message.error('请阅读并确认《免责声明》');
            return false;
        }
        this.$refs['formTime'].validate(valid => {
          if (valid) {
            
            this.msg= "确定提交吗，提交过后将不能修改？";
            
            if (this.checked){
              this.submitTips = true;
            } else{
              this.$message.error('请先选择同意相关内容后再次提交')
            }
          }else{
            this.$message.error('请完善所有带*号的必填项');
            return
          }
        })
      }
    },
    hideBackTips(bool, flag) {
      if (flag) {
//        this.$router.push({path:'register_info',query:{uuid:this.$route.query.signId}});
        this.$router.go(-1);;
      }
      this.backTips = bool;
    },
    
    getDate() {
      this.loading = true;
      this.commitData(this.formaDate);
    },
    commitData(formaDate){
      enroll_choose_again({
        enroll_uuid:formaDate.enroll_uuid,
        intention_class_date_one: formaDate.intention_class_date_one,
        intention_class_date_two: formaDate.intention_class_date_two,
        intention_class_periods_one: formaDate.intention_class_periods_one,
        intention_class_periods_two: formaDate.intention_class_periods_two,
      }).then(res=>{
        this.loading = false;
        // 提交过后 把文件数组清空 避免文件重复
        this.formaDate.report_list=[];
        if (Number(res.data.status) === 0) {
          this.$message.success('意向选择成功，中国足协将于每期培训开班前通过短信通知预录取结果。')
//          this.$router.push({path:'register_info',query:{uuid:this.$route.query.signId}})
          this.$router.go(-1);;
        }else{
        this.$message.error(res.data.msg)
        }this.submitTips = false;
      }).catch(err=>{
        this.loading = false;
        this.submitTips=false;
        console.log(err)
      })
    },
    hideCommitTips(bool, flag) {
      if (flag) {
        this.getDate();
        return;
      }
      this.submitTips=bool;
    },
    handleClick() {
      const that = this;
      that.isShowOntification = true;
      if(that.btnTimer) {
        clearInterval(that.btnTimer)
        that.btnTimer = null;
      }
      if(!this.isConfirmBtnAvaible) {
        that.btnTimer = setInterval(() => {
          that.timerCount -= 1;
          if(!!!that.timerCount) {
            that.isConfirmBtnAvaible = true;
            clearInterval(that.btnTimer)
          }
        }, 1000)
      }
    },
    handleNotificationClose() {
      if(this.showNotification) {
        if(this.isReadStatus) {
          this.isShowOntification = false;
        } else {
          this.isShowOntification = true;
        }
      } else {
        this.isShowOntification = false;
      }
    },
    handleConfirmRead() {
      if(!this.isConfirmBtnAvaible) return
      this.isReadStatus = true; //
      this.isShowOntification = false;
    },
  }
};
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.vita-form-nav, .vita-form-main {
  flex: 1 1 auto;
  height: 100%;
}

.vita-form-nav {
  display: flex;
  align-items: center;

  p {
    font-size: $font_size_big;
  }
}

.vita-form-main {
  width: 100%;

  .content {
    height: calc(100% - 60px);
    padding: 20px 0;
    position: relative;
    background-color: $block_bg_color_base;
    .form-wrap {
      padding: 0 30px 0 25px;

      overflow hidden;
      .vita-form-fieldset {
        margin: 30px 0 30px 0;
        padding: 10px 10px 10px 10px;
        border: 1px solid $color_white;
        position :relative

        .must_accident,.must_physical{
          color $color_err
          position relative
          top 6px
          font-size 20px
        }
        .fujian{
          display flex
          .intro{
            width: 80px;
            text-align: center
          }
          .uploadFujian{
            width: calc(100% - 80px)
            position relative
          }
        }
        .watchFile{
          position absolute;
          left: 120px;
          top: 0
        }
      }

    }
  }

  .btns {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: $color_err; */
  }
}
.flex-column {
  flex-direction column
}
.tips {
  color $color_suc
  text-decoration underline
  cursor pointer
  user-select none
  position relative
}
.red-color {
  color $color_unusual !important
}
.suc {
  color $color_suc
}
.btn {
  cursor pointer
}

.confrimBox
  display flex
  align-items center
  justify-content center

.word-wrapper
  height 480px
  .word-content
    margin 0px 10px
</style>
<style lang="stylus">
.el-progress__text, .el-upload-list__item-name{
  color: #fff;
}
.vita-form-main
  .el-form-item__label {
    color: #fff;
  }

.no-padding
  .el-dialog__body
    padding  30px 10px
</style>
